import { render } from "./Shopcard.vue?vue&type=template&id=476c62df&scoped=true"
import script from "./Shopcard.vue?vue&type=script&lang=js"
export * from "./Shopcard.vue?vue&type=script&lang=js"

import "./Shopcard.vue?vue&type=style&index=0&id=476c62df&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-476c62df"

export default script